var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74.375 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 2.188,
    y: 2.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.936 78.782l33.973-19.434V20.577l-33.973 19.38v38.825z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.028 59.337l33.93 19.402V39.968L1.028 20.609v38.728zm67.645-38.76L34.958 1.337 1.242 20.577 34.958 39.85l33.716-19.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.957 38.707l31.757-18.108-.032-.022-31.725 18.13h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.232 20.577l-.032.022 31.757 18.108h0L3.232 20.577z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.957 38.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.844 19.337L34.957 0 1.07 19.337 0 19.973v40.011l33.93 19.402L35 80l1.07-.614L70 59.984V19.962zm-1.07 39.396L36.028 76.907V40.582l31.789-18.141zM33.887 76.907L2.098 58.723V22.441l31.789 18.141zM3.232 20.598L34.957 2.479l31.725 18.119h0L34.957 38.707h0L3.2 20.598z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#96bf3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.096 60.9l18.249-10.423V29.663L35.096 40.075V60.9zM16.569 50.477L34.818 60.9V40.075L16.569 29.663v20.814zm36.584-21.094l-18.196-10.38-18.196 10.38 18.196 10.412 18.196-10.412z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.957 38.739l16.366-9.334-.022-.022-16.344 9.345v.011z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.613 29.383l-.021.022 16.365 9.334v-.011l-16.344-9.345z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.957 38.728z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.474 28.143L34.957 17.591 16.44 28.143l-1.07.625v22.431l18.517 10.596 1.07.614 1.07-.614 18.538-10.596V28.769zm-1.07 21.795l-16.376 9.378V40.604l16.398-9.356zm-18.517 9.378l-16.397-9.378v-18.69l16.398 9.356zM18.613 29.383l16.344-9.313 16.344 9.324h0l-16.344 9.334h0l-16.365-9.324z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.7f01f959143d8e3891b4331d0f5ce430.svg";
export { ForwardRef as ReactComponent };